var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sliderBarDialogShell',{staticClass:"addOrMaterialImgTextDialog",attrs:{"dialog-show":_vm.dialogShow,"dialog-title":_vm.title,"click-not-close":true},on:{"close":_vm.beforeClose,"submit":_vm.confirm}},[_c('img-text-content',{ref:"outform",on:{"add-success":_vm.addSuccess,"edit-success":_vm.editSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }